import type { FC } from 'react';
import EmbedYoutube from '../../utils/EmbedYoutube/EmbedYoutube';
import { LetsGetStartedWrapper } from './LetsGetStarted.styled';
import playSubscribe from './../../../resources/videoTutorial/play-subscribe.png';

interface LetsGetStartedProps { }

const LetsGetStarted: FC<LetsGetStartedProps> = () => (
   <LetsGetStartedWrapper data-testid="LetsGetStarted">
      <header className="entry-header ">
         <h1 className="entry-title" itemProp="headline">Let’s get started!</h1>
      </header>
      <div className="entry-content clear" itemProp="text"  style={{height: 'auto !important'}}>
         <p className="text-align-justify">Throughout our training session, we will be covering the following topics :</p>
         <ul className="text-align-justify">
            <li><a href="/java-basics">Programming Basics</a></li>
            <li><a href="/control-statements">Control Statements</a></li>
            <li><a href="/oops-concepts">OOPS Concepts</a></li>
            <li><a href="/core-java">Core Java</a></li>
            <li><a href="/advanced-java">Advanced Java</a></li>
            <li><a href="/java-8-features">Java 8 Features</a></li>
            <li><a href="/spring-framework">Spring Framework</a></li>
            <li><a href="/rest-web-services">REST Web Services</a></li>
         </ul>
      </div>
      <br/>
      <div className="epyt-gallery" data-currpage="1">
         <EmbedYoutube videoType="video" videoList={["wMAEa2U_03k"]} />
         <div className="epyt-gallery-subscribe">
            <a className="epyt-gallery-subbutton" href="https://youtube.com/channel/UCpIueiXyq5nhTJTDuw2DQnA?sub_confirmation=1">
               <img className="lazy-loaded" decoding="async" alt="subscribe" src={playSubscribe} data-lazy-type="image" />
               Subscribe
            </a>
         </div>
      </div>

      <hr />
      <br />
      <EmbedYoutube videoType="playlist" videoList={["wMAEa2U_03k","Q5MnyFfpbls","EjoWkBttAWE","7KixECa4CPM","HQWyn3Yf33k","KkysGYu_YIU","UQ9JOV9z6ko"]} />
      <br/>

   </LetsGetStartedWrapper>
);

export default LetsGetStarted;
